import { Injectable } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { CommsService } from '../../services/comms/comms.service';
import { UserService } from '../../services/user/user.service';
import { SocketService } from '../../services/socket/socket.service';
import { Event } from '../../services/socket/socket.service';

@Injectable()
export class NotificationService {

	pendingActions = [];
	pendingActionsTrimmed = [];
	pendingActionsCount = 0;

	queueItems = [];
	queueItemsTrimmed = [];
	queueCount = 0;

	constructor(
		private configService: ConfigService,
		private dataService: DataService,
		private timesheetService: TimesheetService,
		private commsService: CommsService,
		private userService: UserService,
		private socketService: SocketService
	) { }

	openPendingSocket() {
		this.socketService.initSocket(this.userService.username);

		this.socketService.onMessage()
			.subscribe((message) => {
				this.onSocketMessage(message);
			});

		this.socketService.onEvent(Event.CONNECT)
			.subscribe(() => {
				console.log('SOCKET CONNECTED');
				this.loadQueueItems();
			});

		this.socketService.onEvent(Event.DISCONNECT)
			.subscribe(() => {
				console.log('SOCKET DISCONNECTED');
			});
	}

	closePendingSocket() {
		this.socketService.closeSocket(this.userService.username);
	}

	onSocketMessage(data) {

		console.log('SOCKET MESSAGE', data, this.queueItemsTrimmed);

		if (data['TSAPPROVALSTATUS']) {
			this.updateTimesheet(data['TSAPPROVALSTATUS']);
			let refreshQueue = false;
			this.queueItemsTrimmed.forEach((d, i) => {
				if (d.notificationid === data['TSAPPROVALSTATUS']['_id']) {
					refreshQueue = true;
				}
			});
			console.log('SOCKET TSAPPROVALSTATUS', refreshQueue);
			if (refreshQueue) {
				this.loadQueueItems();
			}
		}
	}

	updateTimesheet(socketMessage) {
		const activeTab = this.timesheetService.getActiveTab(this.timesheetService.tabsData.listTabs);
		const dataRef = this.timesheetService.dataObj + '-' + activeTab['prop'] + '-' + activeTab['type'];
		const currentPageIndex = activeTab['page'];

		if (this.dataService.pageData[dataRef] && this.dataService.pageData[dataRef][currentPageIndex]) {
			this.dataService.pageData[dataRef][currentPageIndex] = this.dataService.pageData[dataRef][currentPageIndex]
				.map(timesheet => {
					if (socketMessage.objid === timesheet._id) {
						const code = socketMessage.status === 'success'
							? 200
							: socketMessage.status === 'failed'
							? 500
							: null;

						timesheet.queueResponse = {
							code: code,
							message: socketMessage.message
						};

						timesheet['queueResponse.code'] = code;
						timesheet['queueResponse.message'] = socketMessage.message;
					}
					return timesheet;
				});
		}
	}

	updateQueueItems(data: Array<any>): void {
		this.resetQueueItems();
		data.forEach((d) => {
			if (d.status === 'pending') {
				const parsedItem = {
					title: this.getQueueTitle(d),
					label: this.getQueueLabel(d),
					notificationid: d._id,
					type: 'queue',
					status: d.status,
					objid: d.objid
				};
				this.queueItems.push(parsedItem);
				this.queueItemsTrimmed.push(parsedItem);
				this.queueCount = this.queueCount + 1;
			}
			if (d.read !== true && d.status !== 'pending') {
				const parsedItem = {
					title: this.getQueueTitle(d),
					label: this.getQueueLabel(d),
					notificationid: d._id,
					type: 'queue',
					status: d.status,
					objid: d.objid
				};
			}
		});
	}

	getQueueTitle(data) {
		switch (data.doctype) {
			case 'tsapproval':
				return 'Timesheet Verification for ' + data.approvalfor + ' on ' + data.ponumber;
		}
	}

	getQueueLabel(data) {
		switch (data.status) {
			case 'success':
				return data.message;
			case 'failed':
				return 'Error: ' + data.message;
		}
	}

	loadQueueItems() {
		this.commsService.getQueueItems().subscribe((res) => {
			const jsonRes = res;
			console.log('LOAD QUEUE ITEMS RES: ', jsonRes);
			const successData = jsonRes[this.configService.detailDataProp];
			this.updateQueueItems(successData);
		}, (err) => {
			// in the case of an error, reset queue items so the queue doesn't continue to display forever
			this.resetQueueItems();
		});
	}

	resetQueueItems() {
		this.queueItems = [];
		this.queueItemsTrimmed = [];
		this.queueCount = 0;
	}

	isInQueue(id) {
		let isInQueue = false;
		const filteredNotes = this.queueItems.filter(note => {
			return note.objid === id;
		});
		if (filteredNotes && filteredNotes.length > 0) {
			isInQueue = true;
		}
		return isInQueue;
	}
}
